import axios from 'axios';
import { useRouteError } from 'react-router-dom';

const instance = axios.create({
    headers: {
        'x-api-key': process.env.NEXT_PUBLIC_X_API_KEY,
        'Accept': 'application/json',
    }
});

instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 403) {
            localStorage.removeItem('accessToken');
            // Use the router from next/router
            const router = useRouteError();
            router.push('/auth/jwt/login');
        }
        return Promise.reject(error);
    }
);

export default instance;
